<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.first_name')" :required="true"
    />
    <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('applicants.last_name')" :required="true"
    />
    <text-input type="date"
                :date-not-in-future="true"
                v-model="form.date_birth" :error="form.errors.date_birth" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('volunteers.date_birth')" :required="true"
    />
    <select-multiple :default-options="languages" v-model="form.language_ids" :error="form.errors.language_ids"
                     class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('applicants.languages')"
                     :placeholder="$t('applicants.placeholder.language')" :hint="$t('applicants.hint.languages')"
    />
    <text-input v-model="form.language_field" :error="form.errors.language_field" class="pb-8 pr-6 w-full lg:w-1/3"
                :label="$t('applicants.language_specify')" v-if="emptyLanguageField"
    />
    <div class="flex flex-wrap w-full">
      <text-input type="tel" v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2"
                  :label="$t('applicants.phone')"
      />
      <text-input type="email" v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2"
                  :label="$t('users.email')"
      />
    </div>
    <div class="flex flex-wrap">
      <text-input v-model="form.street" :error="form.errors.street" class="pb-8 pr-6 w-full lg:w-2/3"
                  :label="$t('applicants.street')"
      />
      <text-input v-model="form.street_number" :error="form.errors.street_number" class="pb-8 pr-6 w-full lg:w-1/3"
                  :label="$t('applicants.street_number')"
      />
      <text-input v-model="form.zip_code" :error="form.errors.zip_code" class="pb-8 pr-6 w-full lg:w-1/2"
                  :label="$t('applicants.zip_code')"
      />
      <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2"
                  :label="$t('applicants.city')"
      />
    </div>

    <text-input
      :date-not-in-future="true"
      type="date" v-model="form.date_entry" :error="form.errors.date_entry" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('volunteers.date_entry')" :required="true"
    />
    <text-input
      :date-not-in-future="true"
      type="date" v-model="form.date_exit" :error="form.errors.date_exit" class="pb-8 pr-6 w-full lg:w-1/2"
                :label="$t('volunteers.date_exit')"
    />
<!--    <text-input  v-model="form.career" :error="form.errors.career" class="pb-8 pr-6 w-full lg:w-2/2"-->
<!--                :label="$t('volunteers.career')"-->
<!--    />-->
<!--    <text-input  v-model="form.hobbies" :error="form.errors.hobbies" class="pb-8 pr-6 w-full lg:w-2/2"-->
<!--                :label="$t('volunteers.hobbies')"-->
<!--    />-->
    <text-input type="date" v-model="form.authorization_date" :error="form.errors.authorization_date"
                class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.authorization_date')"
                :hint="$t('users.hint.authorization_date')"
    />

    <text-input type="number" v-model="form.max_treatments" :error="form.errors.max_treatments"
                class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('volunteers.max_treatments')"
                :hint="$t('volunteers.hint.max_treatments')"
    />
    <checkbox v-if="!viaVolunteer" v-model="form.visitor" :error="form.errors.visitor"
              class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('volunteers.visitor')"
    />
    <checkbox v-if="!viaVolunteer" v-model="form.status" :error="form.errors.status" class="pb-8 pr-6 w-full lg:w-1/2"
              :label="$t('volunteers.active')"
    />
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import Checkbox from '@/Shared/Checkbox'
import SelectMultiple from '@/Shared/SelectMultiple'
import intersectionWith from "lodash/intersectionWith";
import map from "lodash/map";

export default {
  components: {
    TextInput,
    Checkbox,
    SelectMultiple
  },
  props: {
    formData: Object,
    languages: Object,
    viaVolunteer: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    form() {
      return this.formData
    },
    //If request has empty_field (e.g. other), show empty text field
    emptyLanguageField() {
      let content = intersectionWith(this.languages, map(this.form.language_ids, 'id'), (o, id) => o.id === id)
      for (let item of content) {
        if (item.empty_field) {
          return true
        }
      }
      return false
    },
  },
}
</script>
